import type { PortalDsBadgeVariant } from 'src/components/portal-design-system';
import type { SchedulingConnectionStatus, SchedulingRequestStatus } from '../types/scheduling.types';

export function formatSchedulingConnectionStatusLabel(status: SchedulingConnectionStatus): string {
  if (status === 'accepted') {
    return 'Connected';
  }
  return status.charAt(0).toUpperCase() + status.slice(1);
}

export function getSchedulingConnectionBadgeVariant(status: SchedulingConnectionStatus): PortalDsBadgeVariant {
  switch (status) {
    case 'accepted':
      return 'green';
    case 'revoked':
      return 'red';
    default:
      return 'gray';
  }
}

export function formatSchedulingRequestStatusLabel(status: SchedulingRequestStatus): string {
  return status.charAt(0).toUpperCase() + status.slice(1);
}

export function getSchedulingRequestBadgeVariant(status: SchedulingRequestStatus): PortalDsBadgeVariant {
  switch (status) {
    case 'confirmed':
      return 'green';
    case 'cancelled':
      return 'red';
    default:
      return 'gray';
  }
}

export function formatConnectedDate(connectedAt: string | null): string {
  if (!connectedAt) {
    return '—';
  }

  return new Date(connectedAt).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatRequestTime(scheduledAt: string): string {
  return new Date(scheduledAt).toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatRequestDate(scheduledAt: string): string {
  return new Date(scheduledAt).toLocaleDateString('en-GB', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
